// Do NOT add "use client" to this file
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

export const LoggedOutProductName = ({
  productName,
  className,
}: {
  productName: string;
  className?: string;
}) => {
  return (
    <div className="max-w-full">
      <Typography
        className={className ?? "line-clamp-2 whitespace-normal"}
        variant="paragraphSansMedium"
        data-test-id="product-tile-product-name"
        style={{
          wordBreak: "break-word",
        }}
      >
        {productName}
      </Typography>
    </div>
  );
};
